module.exports = __webpack_public_path__ + "img/dummy0.8da1858.jpg";